import { createFileRoute } from '@tanstack/react-router';
import { DevolucaoListPage } from '@/features/devolucao/page/list/DevolucaoListPage';

export const Route = createFileRoute('/a/devolucao/')({
    component: DevolucaoListPage,
});
